import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Dictionary} from '../models/dictionary.model';
import {Store} from '@ngxs/store';

@Injectable()
export class DictionaryService {
    baseUrl = '/api/secured/dictionary';

    constructor(
        private http: HttpClient,
        private store: Store,
    ) {
    }

    fetchDictionary(dictionaryCodes: string) {
        const params: HttpParams = new HttpParams({
            fromObject: {dictionaryCodes}
        });
        return this.http.get<Dictionary[]>(this.baseUrl, {params});
    }

    fetchDictionaries(dictionaryCodes: string[]) {
        const params: HttpParams = new HttpParams({
            fromObject: {code: dictionaryCodes.join(',')}
        });
        return this.http.get<Dictionary[]>(this.baseUrl, {params});
    }
}
